/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../services/globalsettingsservice.ts" />
/// <reference path="datevalidatorbase.ts" />

module App.Common.Directives {
	'use strict';

	export class MustBeEqualOrLaterThan extends Directives.DateValidatorBase {

		public static $inject = ['$filter', 'app.common.services.globalSettingsService'];

		constructor($filter: angular.IFilterService, globalSettings: Common.Services.GlobalSettingsService) {
			super($filter, globalSettings);

			this.comparisonDescription = 'later than or equal to';
		}

		public name = 'must-be-equal-or-later-than';

		public isValid = (args: Directives.ValidateArgs) => {
			return args.modelValue() >= args.parameterValue();
		};
	}

	factory.$inject = ['$filter', 'app.common.services.globalSettingsService'];

	function factory($filter: angular.IFilterService, globalSettings: Common.Services.GlobalSettingsService) {
		return new MustBeEqualOrLaterThan($filter, globalSettings);
	}

	angular
		.module('app.common.directives')
		.directive('mustBeEqualOrLaterThan', factory);
}